import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import tableTeamsContent from './formGroupLiveApps/tableTeamsContent';


export default {
  title: 'Teams',
  attributeName: 'teams',
  fields: [
    {
      attributeName: 'teamsTable',
      type: FormInputTypes.TABLECOMPONENT,
      mode:'POPUP',
      helpText: '',
      configFile: tableTeamsContent,

    },

  ],
};
